import Marquee from "react-fast-marquee";

export function EditorialMarquee({ items = [], testId = "editorial-marquee" }) {
  return (
    <section className="border-y border-border bg-sand/50 py-8" data-testid={testId} aria-hidden="true">
      <Marquee gradient={false} speed={40} className="overflow-hidden">
        {items.concat(items).map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 font-serif text-4xl font-light text-charcoal/80 sm:text-6xl">
            {item}
            <span className="text-terracotta">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
